module.exports = __webpack_public_path__ + "img/close.21c66c8c.png";